export default __webpack_public_path__ + "static/media/Magadhi_am_1.953ec0c0.mp3";